import React, { useState } from "react";

interface LetterBoldProps {
  text: string;
  className?: string;
  baseWeight?: number;
  hoverWeight?: number;
  staggerDelay?: number; // ms per letter
  transitionDuration?: number; // ms
  as?: keyof JSX.IntrinsicElements;
}

const LetterBold: React.FC<LetterBoldProps> = ({
  text,
  className = "",
  baseWeight = 400,
  hoverWeight = 400,
  staggerDelay = 30,
  transitionDuration = 180,
  as: Tag = "span",
}) => {
  const [hovered, setHovered] = useState(false);
  const letters = text.split("");

  return (
    <Tag
      className={`inline-flex cursor-pointer ${className}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ fontWeight: baseWeight }}
    >
      {letters.map((char, i) => (
        <span
          key={`${char}-${i}`}
          className="inline-block transition-all will-change-[font-weight]"
          style={{
            fontWeight: hovered ? hoverWeight : baseWeight,
            transitionProperty: "font-weight",
            transitionDuration: `${transitionDuration}ms`,
            transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)",
            transitionDelay: hovered ? `${i * staggerDelay}ms` : `${(letters.length - 1 - i) * staggerDelay}ms`,
            minWidth: char === " " ? "0.3em" : undefined,
          }}
        >
          {char === " " ? "\u00A0" : char}
        </span>
      ))}
    </Tag>
  );
};

export default LetterBold;
